import { Flex } from 'components';
import styled from 'styled-components';
import { displayTranslatedField } from 'utilities/localizedString';

const ColorBlock = styled(Flex)<{ $background: string }>`
  min-width: 36px;
  height: 36px;
  padding: 0 6px;
  border-radius: 10px;
  background: ${({ $background }) => $background};
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 12px;
  color: #ffffff;
  border: 1px solid ${({ theme }) => theme.palette.neutral.lightGrey};
  flex-shrink: 0;
`;

const Name = styled.span`
  min-width: 0;
`;

interface Props {
  priorityLevel?: {
    name?: string;
    id_code?: string;
    color_code?: string;
    name_translation?: string | null;
    id_code_translation?: string | null;
  };
  name?: string;
  codeId?: string;
  colorCode?: string;
  showName?: boolean;
}

export const PriorityLevelBadge: React.FC<Props> = ({
  priorityLevel,
  name,
  codeId,
  colorCode,
  showName = true
}) => {
  const source = priorityLevel ?? { name, id_code: codeId, color_code: colorCode };
  const labelCode = displayTranslatedField(source, 'id_code').slice(0, 3) || '?';
  const labelName = displayTranslatedField(source, 'name');

  return (
    <Flex alignItems="center" gap="8px" minWidth={0}>
      <ColorBlock $background={source.color_code || '#cccccc'}>{labelCode}</ColorBlock>
      {showName && <Name>{labelName || '—'}</Name>}
    </Flex>
  );
};
